module.exports = __webpack_public_path__ + "img/ZhongXinLogo.7bb24fed.png";